<template>
  <div>
    <Header />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-5 mt-20 mb-10">
        

    

        <div @click="getStudent"
          class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
        >
          <div
            class="lg:px-8 h-full px-6 flex flex-col gap-4"
          >
            <h1
              class="font-bold text-xl lg:text-xl prime text-center"
              v-if="this.userInfo"
            >
            Students
            </h1>

            <p class="content max-w-sm text-center text-lg">
                <span >{{totalCount}}</span>
            </p>

            <!-- <p class="bg-primary text-white px-3 py-1.5 rounded-full text-center">See Details</p> -->

          </div>
        </div>

      </div>
    </div>

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-10 gap-5 mb-20">

        <div class="text-xl font-bold mb-10"> 
            {{ selectInfo }} ({{ totalCount }})
        </div>

        <div
          class="flex flex-col rounded-3xl shadow-xl h-full gap-5 overflow-x-auto"
        >

        <table class="table-auto w-full overflow-x-auto">
          <thead>
            <tr>
             
              <th
                class="p-4 border-b text-center border-r text-blues whitespace-nowrap"
              >
                S NO
              </th>
              <th
                class="p-4 border-b text-center border-r text-blues"
              >
                Name
              </th>
              <th
                class="p-4 border-b border-r text-center text-blues"
              >
                Email
              </th>

              <th class="p-4 border-b text-center text-blues" v-if="this.selectInfo != 'Students'">
                    Change Permission
              </th>

            </tr>
          </thead>
          
          <tbody v-if="instructors.length != 0"
          >
            <tr v-for="(instructor, index) in instructors" :key="instructor">
             
              <td class="p-4 border-b text-center border-r">
                <p class="text-primary">{{ (currentPage - 1) * 10 + index + 1 }}</p>
              </td>
              <td class="p-4 border-b text-center border-r">
                <p  class="text-primary" v-if="instructor.user">
                    {{ instructor.user.display_name }}
                </p>
              
              </td>
              <td class="p-4 border-b text-center border-r">
                <p class="text-primary" v-if="instructor.user">
                    {{ instructor.user.email }}
                </p>
              </td>
              
              <!-- <td class="p-4 border-b text-center border-r">
                <p class="text-primary" v-if="instructor.user">
                    {{ instructor.user.email }}
                </p>
              </td> -->

            
            </tr>
          </tbody>

         

          <tbody v-if="instructors.length == 0"
          >
            <tr>
                <td colspan="4" class="text-center p-4">No Details</td>
            </tr>
          </tbody>

        </table>

        <div class="flex items-center justify-center w-full pb-8"> 
            <Pagination :totalPages="totalPages" @page-changed="getStudent" />
          </div>

        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";
import axios from "axios";

import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Header,
    Footer,
    Pagination
  },
  computed: mapGetters(["userInfo"]),

  data(){
    return {
        staff_data: [],
        instructors: [],
        selectInfo: "Students",
        totalPages: null,
        totalCount: 0,
        currentPage: 1
        // coordinator: [],
        // students: [],
    }
  },

  created(){
    this.getStudent(1);
  },

  methods: {

    getStudent(value){
        // console.log(value, "value::");
        this.currentPage = value;
        this.selectInfo = "Students";
        axios.get(`${process.env.VUE_APP_API}/instructor/student-list/?Key=${this.userInfo.token_key}&page=${value}`)
        .then((response)=>{
            if(response.data.status == 200){
                this.totalCount = response.data.Count;
                this.instructors = response.data.data.data.data;
                this.totalPages = response.data.data.total_page;
            }
        })
        .catch((err)=>{
            console.log(err);
        })
    },
  }

};
</script>

<style></style>
